import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";

import withRouter from '../libs/withRouter.jsx';
import withAuth from "../libs/withAuth.jsx";

import { Button, Heading, Modal, ModalContent, ModalHeader, ModalFooterButtons, DatePicker} from "@vibe/core";

class ModalDatePicker extends React.Component
{
    constructor(props)
    {
        super(props);
        //console.log("ModalDatePicker constructor",this.props);
        this.params = this.props.router.params;
        
        this.state = {
            'show': false,
            'date': (this.props?.date?null:this.props.date),
        };
        
        this.openModalButtonRef = this.props.openModalButtonRef;
                
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        
        this.save = this.save.bind(this);

        this.synStateTimer = false;
    }
    
    async promisedSetState(newState)
    { 
        var state = this.state;
        for(let key of Object.keys(newState))
        {
            state[key] = newState[key];
        }
        
        this.state = state;
        
        var this_component = this;
        if(this.synStateTimer==false)
        {
            this.synStateTimer = setTimeout( () => { 
                this_component.setState( {...this_component.state} );
                this_component.synStateTimer = false; 
            }, 100);
        }
        
        return true;
    }
    
    async showModal()
    {
        var this_component = this;
        
        await this_component.promisedSetState({'show': true, 'date':this_component.props.date});
    }

    async closeModal()
    {
        var this_component = this;
        
        await this_component.promisedSetState({'show': false});
    }
    
    async save(e)
    {
        e.preventDefault();
        var this_component = this;
        
        this_component.props.handleValue(this_component.state.date);

        this_component.closeModal();
    }
    
    async setDate(date)
    {
        var this_component = this;

        await this_component.promisedSetState({'date': date});
    }
    
    render()
    {
        var this_component = this;
       
        return (
            <div style={this_component.props.style}>
                <Modal triggerElement={this_component.openModalButtonRef!=null && ('current' in this_component.openModalButtonRef)?this_component.openModalButtonRef.current:null} show={this_component.state.show} onClose={this_component.closeModal} width={Modal.width.DEFAULT} contentSpacing>
                <ModalHeader style={{'fontWeight':'bold'}}><Heading type="h4" weight="bold" color="primary" className="pl-0 mt-0">Date</Heading></ModalHeader>
                    <ModalContent>
                        <div className="ModalDatePicker_ModalContent">
                            <DatePicker className="DayPicker__always_show" onPickDate={(date) => this_component.setDate(date)} date={this_component.state.date} />
                        </div>
                    </ModalContent>
                    <ModalFooterButtons primaryButtonText="Set" onPrimaryButtonClick={this_component.save} secondaryButtonText="Cancel" onSecondaryButtonClick={this_component.closeModal} />
                </Modal>
            </div>
        );
    }
}

ModalDatePicker.propTypes = {
    'style': PropTypes.object
};

ModalDatePicker.defaultProps = {
    style: {'display': 'none'}
};

export default withRouter(ModalDatePicker);
